const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 20,
    viewBox: "0 0 58 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 166775"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ret\\xE2ngulo 148318",
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 0.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ret\\xE2ngulo 148319",
    transform: "translate(38)",
    style: {
      stroke: "currentColor",
      strokeWidth: 3,
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 17,
    height: 17,
    rx: 0.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 164948"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 1882",
    transform: "translate(25 6.788)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      strokeWidth: 3,
      fill: "none"
    },
    d: "M0 7.6 8 0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Linha 1883",
    transform: "translate(25 6.788)",
    style: {
      strokeLinecap: "round",
      stroke: "currentColor",
      strokeWidth: 3,
      fill: "none"
    },
    d: "M8 7.6 0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuess);
export default __webpack_public_path__ + "static/media/guess.59a6f2baa6ee49e96eb28a988a8bb38f.svg";
export { ForwardRef as ReactComponent };